// Marketing routes are prerendered to static HTML (plan/01 §3, plan/08 SEO):
// full content with zero JS, fast LCP, crawler-friendly. Dynamic routes
// (/api/*, /thanks) opt out individually with `export const prerender = false`.
export const prerender = true;

// No trailing-slash inconsistency — canonical URLs have no trailing slash
// (plan/08 §1). Redirect the other form at the edge (Caddy).
export const trailingSlash = 'never';
